import type { ArticleV1 } from 'types/capi/article';

export default function Title({ article }: { article: ArticleV1 }) {
  return (
    <h1 className="flex w-full text-2xl font-bold md:text-4xl">
      {article.title}
    </h1>
  );
}
